var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    fill: "#E3EDC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0499 51.2999C34.8499 51.2999 34.6665 51.2666 34.4999 51.1999C34.3332 51.1333 34.1665 51.0166 33.9999 50.8499L24.9499 41.7999C24.6499 41.4999 24.4999 41.1333 24.4999 40.6999C24.4999 40.2666 24.6499 39.8999 24.9499 39.5999C25.2499 39.2999 25.5999 39.1499 25.9999 39.1499C26.3999 39.1499 26.7499 39.2999 27.0499 39.5999L35.0499 47.5999L53.1999 29.4499C53.4999 29.1499 53.8582 28.9999 54.2749 28.9999C54.6915 28.9999 55.0499 29.1499 55.3499 29.4499C55.6499 29.7499 55.7999 30.1083 55.7999 30.5249C55.7999 30.9416 55.6499 31.2999 55.3499 31.5999L36.0999 50.8499C35.9332 51.0166 35.7665 51.1333 35.5999 51.1999C35.4332 51.2666 35.2499 51.2999 35.0499 51.2999Z",
    fill: "#274642"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#274642",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheck);
export default __webpack_public_path__ + "static/media/round-check.1638a24a2ab5907c2b58e625f9ccbbe1.svg";
export { ForwardRef as ReactComponent };